import { US, NO, SE, FI, EE, GB } from "country-flag-icons/react/3x2"

import { cn } from "~/lib/utils"

// Real flag SVGs (country-flag-icons), not emoji, consistent across platforms
// and crisp at any size. 3:2 rectangles with sharp ("squared") corners per the
// brand. A thin inset ring delineates the white-heavy flags (FI, EE) against
// light backgrounds.
const FLAGS = { US, NO, SE, FI, EE, GB } as const

export type FlagCode = keyof typeof FLAGS

const NAMES: Record<FlagCode, string> = {
  US: "United States",
  NO: "Norway",
  SE: "Sweden",
  FI: "Finland",
  EE: "Estonia",
  GB: "United Kingdom",
}

export function Flag({
  code,
  className,
}: {
  code: FlagCode
  className?: string
}) {
  const Svg = FLAGS[code]
  return (
    <Svg
      title={NAMES[code]}
      className={cn(
        "h-4 w-6 shrink-0 ring-1 ring-inset ring-black/10",
        className,
      )}
    />
  )
}
